<template>

  <t-page>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">


      <template #search>


        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'" primary/>


        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         placeholder="Nome, Cód., WhatsApp, CNPJ"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">


          <t-input-search v-model="form.typeCustomerId"
                          required
                          select
                          :options="typeCustomerOptions"
                          label="Perfil">
          </t-input-search>

          <t-input-search v-model="form.typeOriginCustomerId"
                          :options="typeOriginCustomerOptions"
                          required
                          label="Origem" select>
          </t-input-search>

          <t-input-search v-if="accountModule === 'production'" v-model="form.typeQualityAppraisalId" :options="typeQualityAppraisalOptions" select
                          label="Tipo de Certificado de Qualidade"/>


        </t-content-header-search-default>

      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               link-primary-column="nameAutomatically"
               primary-key-column="customerNumber">

      </t-table>


    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import http from "@/services/config/http-common";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'Customers',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      form: {
        typeQualityAppraisalId: 0,
        typeOriginCustomerId: 0,
        typeCustomerId: 0,
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      typeQualityAppraisalOptions: [],
      typeCustomerOptions: [],
      typeOriginCustomerOptions: [],
      accountModule: "",
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.accountModule = ui.getAccountModule()

    },
    async mountedContinued() {

      await http.list(this.userAuth.currentPage.path + "/selectRelationList").then((response) => {

        this.typeQualityAppraisalOptions = response.typeQualityAppraisalOptions
        this.typeCustomerOptions = response.typeCustomerOptions
        this.typeOriginCustomerOptions = response.typeOriginCustomerOptions

      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
